
import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
// import contacts from '../contact/contacts-short.js'
// import contacts from '../contact/contacts-short.json'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    provinces: ['QC', 'ON', 'NO TAXES', 'NB', 'BC', 'NL', 'NS', 'PE', 'MB', 'SK', 'AB', 'NT', 'NU', 'YT', 'TPS'],
    user: null,
    userInfo: null,
    allContacts: {},
    search: null,
    searchFields: {},
    searchLastPage: 0,
    authorization: null,
    primaryAuthorization: null,
    availableCompanies: [],
    isSidebarOpen: false, // Toggle sidebar arrow
    dashboardFilterData: {
      dateRange: {},
      filteredOrderStatuses: [],
      selectedZoneParam: {label: 'processing', value: 'processing'},
      filteredZones: [],
      highlightedRow: ''
    },
    chatMessages: null, // To store the latest chat messages
    alerts: {
      marketplace: 0
    },
    featureFlags: null,
    // Deliveries state
    deliveries: [],
    deliveriesIndexByKey: {},
    deliveriesLoaded: false,
    // Zones state
    zones: [],
    zonesLoaded: false,
    // Inventory lots are read once per company and re-read after lot writes (no live listener).
    inventoryLots: [],
    inventoryLotsLoaded: false
  },
  getters,
  mutations,
  actions
})
